import {diff} from "deep-object-diff"
import _ from "lodash"

export default {
  newConfig: () => ({
    enabled: false,
    addAuthorizationHeader: false,
    tabBar: {
      title: null,
      titleEs: null,
      unselectedImage: {
        isRemote: false,
        location: null,
      },
      selectedImage: {
        isRemote: false,
        location: null,
      },
    },
    moreMenu: {
      title: null,
      titleEs: null,
      image: {
        isRemote: false,
        location: null,
      },
    },
    urls: {
      en: null,
      es: null,
    },
  }),
  newScoreboardOverride: () => ({
    addAuthorizationHeader: false,
    urls: {
      en: null,
      es: null,
    },
  }),
  configsAreEqual(config1, config2) {
    const copy1 = _.cloneDeep(config1)
    delete copy1.date
    const copy2 = _.cloneDeep(config2)
    delete copy2.date
    return Object.entries(diff(copy1, copy2)).length === 0
  },
}
